import { render, staticRenderFns } from "./TSMLists.vue?vue&type=template&id=7649d139&"
import script from "./TSMLists.vue?vue&type=script&lang=js&"
export * from "./TSMLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports